import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import Layout from '../../layout/userLayout'

type Props = {
  children?: React.ReactNode
}

const GuestRoute = ({ children }: Props) => {
  const authenticated = useAuthStore((state: any) => state.authenticated)

  return !authenticated ? (
    <Layout>{children ? children : <Outlet />}</Layout>
  ) : (
    <Navigate to="/dashboard" replace />
  )
}

export default GuestRoute
